import isAfterDateUtil from 'utils/date/is-after'

/**
 * @param fastTrackExpirationDate
 * @param fastTrackExtensionExpirationDate
 * @return {*|Date}
 */
const getFastTrackExpireOrExtensionDateLoyaltySelectUtil = ({
  fastTrackExpirationDate,
  fastTrackExtensionExpirationDate
}) => {
  if (
    !fastTrackExpirationDate ||
    !fastTrackExtensionExpirationDate
  ) {
    return
  }

  const now = new Date()
  if (isAfterDateUtil(now, fastTrackExpirationDate)) {
    return fastTrackExtensionExpirationDate
  }

  return fastTrackExpirationDate
}

export default getFastTrackExpireOrExtensionDateLoyaltySelectUtil
